module.exports = __webpack_public_path__ + "img/2318.14eff1e5.gif";